"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invitationFactory = exports.invitationPersonaFactory = exports.invitationOrganizationFactory = exports.invitationInvitedUserFactory = exports.invitationEmailFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const persona_1 = require("../../../mocks/persona");
const mocks_1 = require("../../../mocks");
exports.invitationEmailFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    address: persona_1.persona.email,
});
exports.invitationInvitedUserFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    first_name: persona_1.persona.first_name,
    last_name: persona_1.persona.last_name,
});
exports.invitationOrganizationFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    name: mocks_1.orgNgb.name,
    logo: null,
    logo_data: {}
});
exports.invitationPersonaFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    date_of_birth: persona_1.persona.date_of_birth,
    first_name: persona_1.persona.first_name,
    gender: persona_1.persona.gender,
    last_name: persona_1.persona.last_name,
    middle_name: null,
    nickname: null,
    suffix: null
});
exports.invitationFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    email_address: exports.invitationEmailFactory.build(),
    invited_user: exports.invitationInvitedUserFactory.build(),
    organization: exports.invitationOrganizationFactory.build(),
    originator_id: uuid_1.v4(),
    originator_type: 'TestOriginatorType',
    originator_system: 'TestOriginatorSystem',
    principal_id: uuid_1.v4(),
    principal_type: 'TestPrincipalType',
    principal_system: 'TestPrincipalSystem',
    persona: exports.invitationPersonaFactory.build(),
    status: 'sent',
    originator_uuid: null,
    after_claim_uri: null,
    suggested_persona: null,
    duplicate_personas: [],
    flow_tags: [],
    updated_at: null,
    is_guardian: false
});
